import html2canvas from 'html2canvas';

export async function generateResultImage(element: HTMLElement): Promise<Blob | null> {
  try {
    const canvas = await html2canvas(element, {
      width: 1080,
      height: 1080,
      scale: 1,
      useCORS: true,
      backgroundColor: null,
      logging: false,
    });

    return new Promise((resolve) => {
      canvas.toBlob((blob) => {
        resolve(blob);
      }, 'image/png');
    });
  } catch (error) {
    console.error('Failed to generate image:', error);
    return null;
  }
}

export function downloadImage(blob: Blob, filename: string = '기대수명-결과.png') {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
